import React from "react";
import "./projects.css";
import contactImg from "../../assets/contact.png";
import quizImg from "../../assets/quiz.png";
import calImg from "../../assets/cal.jpg";

const Projects = () => {
  return (
    <section className="projects section" id="projects">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">Some things I have built</span>

      <div className="projects__container container grid">
        {/* Project 1 */}
        <div className="project__card">
          <img
            src={contactImg}
            alt="Hospital Management System"
            className="project__img"
          />

          <h3 className="project__title">Smart Contact Manager</h3>

          <p className="project__description">
            A secure Java Spring Boot web application that allows users
            to manage personal and professional contacts with role-based
            authentication, OAuth login, image storage using Cloudinary,
            and MySQL database integration.
          </p>
          <div className="project__buttons">
            <a
              href="https://github.com/sunnyprakashsp/ContactManager"
              className="project__button"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            <a
              href="https://github.com/sunnyprakashsp/ContactManager"
              className="project__button project__button-outline"
              target="_blank"
              rel="noreferrer"
            >
              Live Demo
            </a>
          </div>
        </div>

        {/* Project 2 */}
        <div className="project__card">
          <img src={quizImg} alt="Online Food Ordering System" />
          <h3 className="project__title">Quiz Application</h3>

          <p className="project__description">
            Quiz App is an interactive web application that allows users to
            attempt multiple-choice quizzes, view scores instantly, and improve
            learning using Java, JavaFX, and MySQL.
          </p>

          <div className="project__buttons">
            <a
              href="https://github.com/sunnyprakashsp/QuizApp"
              className="project__button"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            <a href="https://github.com/sunnyprakashsp/QuizApp" className="project__button project__button-outline">
              Live Demo
            </a>
          </div>
        </div>

        {/* Project 3 */}
        <div className="project__card">
          <img src={calImg} alt="Employee Management System" />

          <h3 className="project__title">Calculator Website</h3>

          <p className="project__description">
            Calculator is a simple and responsive web application that performs
            basic arithmetic operations like addition, subtraction,
            multiplication, and division using HTML, CSS, and JavaScript.
          </p>

          <div className="project__buttons">
            <a
              href="https://github.com/sunnyprakashsp/calculator-LGMVIP"
              className="project__button"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            <a href="https://webcalculator1.netlify.app/" className="project__button project__button-outline">
              Live Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
